"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useVariant = void 0;
var _useVariationParams = require("./use-variation-params");
/*
 * Copyright (c) 2022, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

// Hooks

/**
 * This hook returns the currently selected
 * variant or undefined. NOTE: All attributes must be selected before a variant
 * will be returned.
 *
 * @param {Object} product
 * @returns {Object} the currently selected `Variant` object.
 */
const useVariant = (product = {}, isProductPartOfSet = false) => {
  var _product$type, _product$type2;
  const {
    variants = []
  } = product;
  const variationParams = (0, _useVariationParams.useVariationParams)(product, isProductPartOfSet);

  // Get a filtered array of variants. The resulting array will only have variants
  // which have all the current variation params values set.
  const filteredVariants = variants.filter(({
    variationValues
  }) =>
  // A single liner that will return true if the current variation has all the
  // same attribute values as the passing in params.
  Object.keys(variationParams).every(key => variationValues[key] === variationParams[key]));
  let variant = undefined;
  // @ts-ignore
  if (product.id && (_product$type = product.type) !== null && _product$type !== void 0 && _product$type.variant && filteredVariants.length === 1) {
    variant = filteredVariants[0];
    // @ts-ignore
  } else if (product.id && !((_product$type2 = product.type) !== null && _product$type2 !== void 0 && _product$type2.variant)) {
    var _product$c_inventory;
    variant = {
      // @ts-ignore
      name: product.name,
      // @ts-ignore
      orderable: (_product$c_inventory = product.c_inventory) === null || _product$c_inventory === void 0 ? void 0 : _product$c_inventory.orderable,
      // @ts-ignore
      price: product.price,
      // @ts-ignore
      productId: product.id,
      variationValues: {}
    };
  }
  return variant;
};
exports.useVariant = useVariant;